import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import useSubmittedProposals from '../../hooks/useSubmittedProposals'
import { downloadZipFile } from './utils/fileDownload'

function getMaterialDownloadUrls(data) {
  if (!Array.isArray(data)) {
    return []
  }
  return data.map(doc => {
    return {
      id: doc.id,
      pseudonym: doc.pseudonym,
      downloadUrl: doc.excel.downloadUrl,
      fileName: doc.excel.fileName
    }
  })
}

const DownloadExcelFiles = ({ setLoading, setError }) => {
  const { excelData } = useSubmittedProposals()
  const { t } = useTranslation('proposals')
  const urls = getMaterialDownloadUrls(excelData)

  const handleDownload = () => {
    downloadZipFile('Excel files.zip', urls, setLoading, setError)
  }

  return <Wrapper onClick={handleDownload}>{t('Excel files')}</Wrapper>
}

export default DownloadExcelFiles

const Wrapper = styled.div`
  padding-top: 10px;
  padding-bottom: 10px;
`
